export default __webpack_public_path__ + "static/media/kpi.card.dark.pattern.bfc4db73.svg";